export class UserInfo {
}
UserInfo.onLogin = {};
UserInfo.onLogout = {};
UserInfo.onJWTUpdated = {};
UserInfo.onNotLoggedIn = {};
UserInfo.onLoginFailed = {};
UserInfo.onLoginSucceed = {};
UserInfo.onDataUpdated = {}; //triggered when user information is loaded/updated
UserInfo.onUpdateBalance = {}; //triggered when balance is loaded/updated
UserInfo.onGetBalance = {}; //triggered when balance and open bets are loaded/updated
UserInfo.onLimitationsDataUpdated = {};
UserInfo.onCaptcha = {};
UserInfo.onTokenLogin = {};
UserInfo.OnTwoStepNativeLogin = {};
UserInfo.onAcceptOddsChanged = {};
UserInfo.onTokenLoginReceived = {};
UserInfo.onOneTimeTokenReceived = {};
UserInfo.onOneTimeTokenLoginFailed = {};
UserInfo.onSessionKeepAlive = {};
//# sourceMappingURL=UserInfo.js.map